import React, { useEffect, useState } from "react";
import axios from "axios";
import "./rolling.css";

const API_BASE = "https://spst.in/myapp/api/uploads";

function NewsEvents() {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_BASE}/get_notice.php`);

      const data = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.data)
        ? res.data.data
        : [];

      setUploads(data);
    } catch (error) {
      console.error("Error loading latest updates:", error);
      setUploads([]);
    } finally {
      setLoading(false);
    }
  };

  const openNotice = (row) => {
    if (!row.file_path) return;

    let fileUrl = row.file_path;

    // If API already returns a full URL
    if (
      fileUrl.startsWith("http://") ||
      fileUrl.startsWith("https://")
    ) {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // Remove starting slash if available
    fileUrl = fileUrl.replace(/^\/+/, "");

    // If path already contains myapp/
    if (fileUrl.startsWith("myapp/")) {
      window.open(
        `https://spst.in/${fileUrl}`,
        "_blank",
        "noopener,noreferrer"
      );
      return;
    }

    window.open(
      `https://spst.in/myapp/${fileUrl}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <div className="news-ticker">
      {/* Fixed title */}
      <div className="news-ticker-title">
        <span className="news-ticker-title-icon">
          <i className="fa fa-bullhorn" aria-hidden="true"></i>
        </span>

        <span>Latest Updates</span>
      </div>

      {/* Moving area */}
      <div className="news-ticker-window">
        {loading ? (
          <div className="news-ticker-status">
            Loading latest updates...
          </div>
        ) : uploads.length === 0 ? (
          <div className="news-ticker-status">
            No latest updates available.
          </div>
        ) : (
          <div className="news-ticker-track">
            {uploads.map((row, index) => (
              <div
                key={row.id || index}
                className={`news-ticker-item ${
                  row.file_path ? "clickable" : ""
                }`}
                onClick={() => openNotice(row)}
                title={
                  row.file_path
                    ? "Click to view"
                    : row.name
                }
              >
                <span className="news-ticker-arrow">
                  <i
                    className="fa fa-angle-double-right"
                    aria-hidden="true"
                  ></i>
                </span>

                <span className="news-ticker-text">
                  {row.name}
                </span>

                {row.file_path && (
                  <span className="news-ticker-file">
                    <i
                      className="fa fa-external-link"
                      aria-hidden="true"
                    ></i>
                  </span>
                )}

                {index < uploads.length - 1 && (
                  <span className="news-ticker-separator">
                    •
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default NewsEvents;